import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DualList from '../DualListBox/DualList';
import { CancelButton, SaveButton } from './styledComponents';

const MarketPopup = ({
  updateSelectedItems,
  selectedMarketList,
  closeModal,
  options,
  searchLabel,
  selectedListLabel,
  availableListLabel,
  searchPlaceHolder,
  optionName,
}) => {
  const [selected, setSelected] = useState([]);
  const [isMarketNotSelected, setIsMarketNotSelected] = useState(false);
  const updateSelItems = items => {
    setIsMarketNotSelected(false);
    setSelected(items);
  };
  const selectedMarket = item => {
    updateSelectedItems(selected);
  };
  const closeClicked = () => {
    closeModal();
  };
  return (
    <Fragment>
      <div className="market">
        <DualList
          updateSelectedItems={updateSelItems}
          options={options}
          selectedList={selectedMarketList}
          searchLabel={searchLabel}
          selectedListLabel={selectedListLabel}
          availableListLabel={availableListLabel}
          searchPlaceHolder={searchPlaceHolder}
          optionName={optionName}
        />
      </div>
      <div className="maket-save">
        {isMarketNotSelected && (
          <span className="market-error">Please Make a Selection</span>
        )}
        <CancelButton
          onClick={() => {
            closeClicked();
          }}
        >
          Cancel
        </CancelButton>
        <SaveButton
          disabled={!selected}
          onClick={() => {
            selectedMarket(selected);
          }}
        >
          {optionName === 'MEMRI-USERS' ? 'Save' : 'Done'}
        </SaveButton>
      </div>
    </Fragment>
  );
};
MarketPopup.propTypes = {
  updateSelectedItems: PropTypes.func,
  selectedMarketList: PropTypes.arrayOf(PropTypes.object),
  closeModal: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  searchLabel: PropTypes.string,
  selectedListLabel: PropTypes.string,
  availableListLabel: PropTypes.string,
  searchPlaceHolder: PropTypes.string,
  optionName: PropTypes.string,
};

export default MarketPopup;
